import { environment } from '@env/environment';
import * as Sentry from '@sentry/angular';
import { captureConsoleIntegration } from '@sentry/angular';

export async function initSentry(): Promise<void> {
  if (environment.production) {
    const { version } = await import('package.json');

    Sentry.init({
      dsn: 'https://8fac0fe843c9a3b9f4685435ac728ea9@sentry.zeffi.dev/2',
      release: version,
      environment: environment.debug ? 'dev' : 'prod',
      ignoreErrors: [
        'NG0908',
        'NG05604',

        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
        'Error loading ScrollTimeline script',
        'Importing a module script failed',
        'permission_denied',
        'PERMISSION_DENIED',
        'fetch dynamically imported module',
        'Failed to fetch (api.segment.io)',
        'Object Not Found Matching Id',
        'INTERNAL ASSERTION FAILED: Pending promise was never set',
      ],
      integrations: [captureConsoleIntegration({ levels: ['error'] })],
    });
  }
}
